import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={438.148}
      height={291.869}
      viewBox="0 0 438.148 291.869"
      {...props}
    >
      <g data-name="Group 700">
        <g data-name="Group 55">
          <g data-name="Group 1" fill="#aedcfe">
            <path
              data-name="Path 1"
              d="M395.42 248.115c17.871-8.675 34.032-22.627 40.058-40.785 5-15.065 2.519-31.524-3.639-45.969-13.856-32.5-43.766-52.055-75.228-58.734-16.066-3.411-32.128-.55-47.968-3.646-20.376-3.983-39.542-13.6-57.423-24.963-25.962-16.5-50.315-36.266-79.946-45.927-44.551-14.527-97.841-2.498-131.991 29.473s-47.687 82.26-34.029 125.173 53.736 76.618 100.19 84.685c39.192 6.805 79.557-3.455 119.538-5.368 57.518-2.752 118.745 11.152 170.438-13.939z"
              opacity={0.62}
            />
            <circle
              data-name="Ellipse 1"
              cx={34.784}
              cy={34.784}
              transform="rotate(-103.283 202.125 -91.909)"
              opacity={0.62}
              r={34.784}
            />
            <circle
              data-name="Ellipse 2"
              cx={12.357}
              cy={12.357}
              transform="scale(-1) rotate(7.07 434.765 -282.891)"
              opacity={0.62}
              r={12.357}
            />
          </g>
          <g data-name="Group 39">
            <g data-name="Group 13" transform="translate(51.788 57.401)">
              <rect
                data-name="Rectangle 1"
                width={92.172}
                height={59.796}
                rx={5.571}
                fill="#374c7f"
              />
              <g data-name="Group 12" transform="translate(2.258 1.821)">
                <rect
                  data-name="Rectangle 2"
                  width={94.267}
                  height={61.155}
                  rx={5.266}
                  fill="#bcc0ce"
                />
                <path
                  data-name="Path 2"
                  d="M4.259 59.495h85.863a2.385 2.385 0 002.385-2.385V7.568A1.869 1.869 0 0090.638 5.7h-86.9A1.868 1.868 0 001.87 7.568V57.11a2.385 2.385 0 002.389 2.385z"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 3"
                  width={87.661}
                  height={8.983}
                  rx={4.492}
                  transform="translate(3.148 7.189)"
                  fill="#374c7f"
                />
                <rect
                  data-name="Rectangle 4"
                  width={54.066}
                  height={3.418}
                  rx={1.241}
                  transform="translate(19.131 9.791)"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 5"
                  width={17.255}
                  height={3.418}
                  rx={1.148}
                  transform="translate(70.417 9.791)"
                  fill="#def6f8"
                />
                <path
                  data-name="Line 1"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={0.597}
                  d="M68.508 11.5H50.744"
                />
                <path
                  data-name="Line 2"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={0.597}
                  d="M85.329 11.5H73.197"
                />
                <path
                  data-name="Path 3"
                  d="M19.994 9.791h5.316v3.418h-5.316a.863.863 0 01-.863-.863v-1.693a.862.862 0 01.863-.862z"
                  fill="#f5ad49"
                />
                <g
                  data-name="Group 2"
                  fill="none"
                  stroke="#fff"
                  strokeMiterlimit={10}
                  strokeWidth={0.398}
                >
                  <path
                    data-name="Path 4"
                    d="M22.014 11.168a.9.9 0 10.9-.9.9.9 0 00-.9.9z"
                  />
                  <path data-name="Line 3" d="M22.22 11.74l-.959.959" />
                </g>
                <path
                  data-name="Path 5"
                  d="M14.847 9.133h-2.015l-.968 2.852H7.732l-.446-2.251"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={0.89}
                />
                <ellipse
                  data-name="Ellipse 3"
                  cx={0.863}
                  cy={0.971}
                  rx={0.863}
                  ry={0.971}
                  transform="translate(9.017 8.814)"
                  fill="#f5ad49"
                />
                <path
                  data-name="Path 6"
                  d="M10.642 13.584a.745.745 0 10.745-.745.745.745 0 00-.745.745z"
                  fill="#fff"
                />
                <path
                  data-name="Path 7"
                  d="M7.866 13.584a.745.745 0 10.745-.745.745.745 0 00-.745.745z"
                  fill="#fff"
                />
                <g data-name="Group 3" transform="translate(14.847 51.486)">
                  <rect
                    data-name="Rectangle 6"
                    width={30.471}
                    height={4.609}
                    rx={1.492}
                    transform="translate(0 .549)"
                    fill="#374c7f"
                  />
                  <rect
                    data-name="Rectangle 7"
                    width={30.471}
                    height={4.609}
                    rx={1.492}
                    fill="#ff4747"
                  />
                </g>
                <g data-name="Group 4" fill="#f5ad49">
                  <path
                    data-name="Path 8"
                    d="M29.437 35.2l-.591 1.2-1.32.192.955.931-.226 1.315 1.181-.621 1.181.621-.226-1.315.955-.931-1.32-.192z"
                  />
                  <path
                    data-name="Path 9"
                    d="M25.249 35.2l-.591 1.2-1.32.192.955.931-.226 1.315 1.181-.621 1.181.621-.225-1.315.955-.931-1.32-.192z"
                  />
                  <path
                    data-name="Path 10"
                    d="M21.06 35.2l-.591 1.2-1.32.192.955.931-.225 1.315 1.181-.621 1.181.621-.226-1.315.955-.931-1.32-.192z"
                  />
                  <path
                    data-name="Path 11"
                    d="M16.87 35.2l-.59 1.2-1.32.192.955.931-.226 1.315 1.181-.621 1.181.621-.225-1.315.955-.931-1.32-.192z"
                  />
                  <path
                    data-name="Path 12"
                    d="M12.682 35.2l-.59 1.2-1.32.192.955.931-.226 1.315 1.181-.621 1.181.621-.226-1.315.956-.931-1.32-.192z"
                  />
                </g>
                <g data-name="Group 10" transform="translate(10.384 43.09)">
                  <rect
                    data-name="Rectangle 8"
                    width={37.838}
                    height={5.723}
                    rx={1.852}
                    fill="#f5ad49"
                  />
                  <g data-name="Group 9" fill="#374c7f">
                    <g data-name="Group 5">
                      <path
                        data-name="Rectangle 9"
                        d="M10.338 1.08h.675v3.564h-.675z"
                      />
                      <path
                        data-name="Rectangle 10"
                        d="M8.894 2.524h3.564v.675H8.894z"
                      />
                      <path
                        data-name="Rectangle 11"
                        d="M9.655 4.361l-.477-.477 2.52-2.52.477.477z"
                      />
                      <path
                        data-name="Rectangle 12"
                        d="M11.697 4.361l-2.52-2.52.477-.478 2.52 2.52z"
                      />
                    </g>
                    <g data-name="Group 6">
                      <path
                        data-name="Rectangle 13"
                        d="M16.034 1.08h.675v3.564h-.675z"
                      />
                      <path
                        data-name="Rectangle 14"
                        d="M14.59 2.524h3.564v.675H14.59z"
                      />
                      <path
                        data-name="Rectangle 15"
                        d="M15.351 4.361l-.477-.477 2.52-2.52.477.477z"
                      />
                      <path
                        data-name="Rectangle 16"
                        d="M17.393 4.361l-2.52-2.52.477-.477 2.52 2.52z"
                      />
                    </g>
                    <g data-name="Group 7">
                      <path
                        data-name="Rectangle 17"
                        d="M21.73 1.08h.675v3.564h-.675z"
                      />
                      <path
                        data-name="Rectangle 18"
                        d="M20.286 2.524h3.564v.675h-3.564z"
                      />
                      <path
                        data-name="Rectangle 19"
                        d="M21.047 4.361l-.477-.477 2.52-2.52.477.477z"
                      />
                      <path
                        data-name="Rectangle 20"
                        d="M23.089 4.361l-2.52-2.52.477-.478 2.52 2.52z"
                      />
                    </g>
                    <g data-name="Group 8">
                      <path
                        data-name="Rectangle 21"
                        d="M27.426 1.08h.675v3.564h-.675z"
                      />
                      <path
                        data-name="Rectangle 22"
                        d="M25.982 2.524h3.564v.675h-3.564z"
                      />
                      <path
                        data-name="Rectangle 23"
                        d="M26.743 4.361l-.477-.477 2.52-2.52.477.477z"
                      />
                      <path
                        data-name="Rectangle 24"
                        d="M28.785 4.361l-2.52-2.52.477-.478 2.52 2.52z"
                      />
                    </g>
                  </g>
                </g>
                <path
                  data-name="Path 13"
                  d="M88.331 3.021a1.239 1.239 0 101.239-1.238 1.238 1.238 0 00-1.239 1.238z"
                  fill="#374c7f"
                />
                <path
                  data-name="Path 14"
                  d="M83.355 3.021a1.239 1.239 0 101.239-1.238 1.238 1.238 0 00-1.239 1.238z"
                  fill="#ff4747"
                />
                <path
                  data-name="Path 15"
                  d="M78.375 3.021a1.239 1.239 0 101.238-1.238 1.238 1.238 0 00-1.238 1.238z"
                  fill="#fff"
                />
                <path
                  data-name="Line 4"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.214}
                  d="M48.222 21.129H10.384"
                />
                <path
                  data-name="Line 5"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.214}
                  d="M48.222 26.609H10.384"
                />
                <path
                  data-name="Line 6"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.214}
                  d="M48.222 32.089H10.384"
                />
                <path
                  data-name="Line 7"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.214}
                  d="M48.222 37.568H33.951"
                />
              </g>
            </g>
            <g data-name="Group 25" transform="translate(248.839 28.219)">
              <rect
                data-name="Rectangle 25"
                width={117.97}
                height={76.532}
                rx={7.131}
                transform="translate(4.086 4.479)"
                fill="#374c7f"
              />
              <g data-name="Group 24">
                <rect
                  data-name="Rectangle 26"
                  width={119.42}
                  height={77.473}
                  rx={6.67}
                  fill="#bcc0ce"
                />
                <path
                  data-name="Path 22"
                  d="M5.396 75.37h108.773a3.021 3.021 0 003.021-3.021V9.587a2.367 2.367 0 00-2.367-2.367H4.741a2.366 2.366 0 00-2.366 2.367v62.761a3.021 3.021 0 003.021 3.022z"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 27"
                  width={111.051}
                  height={11.38}
                  rx={5.69}
                  transform="translate(3.988 9.107)"
                  fill="#374c7f"
                />
                <rect
                  data-name="Rectangle 28"
                  width={68.492}
                  height={4.331}
                  rx={1.572}
                  transform="translate(24.236 12.403)"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 29"
                  width={21.859}
                  height={4.331}
                  rx={1.454}
                  transform="translate(89.206 12.403)"
                  fill="#def6f8"
                />
                <path
                  data-name="Line 8"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={0.757}
                  d="M86.788 14.568H64.284"
                />
                <path
                  data-name="Line 9"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={0.757}
                  d="M108.097 14.568h-15.37"
                />
                <path
                  data-name="Path 23"
                  d="M25.329 12.403h6.734v4.33h-6.734a1.093 1.093 0 01-1.093-1.093v-2.144a1.092 1.092 0 011.093-1.093z"
                  fill="#f5ad49"
                />
                <g
                  data-name="Group 14"
                  transform="translate(26.934 13.007)"
                  fill="none"
                  stroke="#fff"
                  strokeMiterlimit={10}
                  strokeWidth={0.505}
                >
                  <circle
                    data-name="Ellipse 4"
                    cx={1.14}
                    cy={1.14}
                    transform="translate(.955)"
                    r={1.14}
                  />
                  <path data-name="Line 10" d="M1.215 1.865L0 3.08" />
                </g>
                <path
                  data-name="Path 24"
                  d="M18.808 11.57h-2.556l-1.227 3.614H9.789l-.565-2.852"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.128}
                />
                <ellipse
                  data-name="Ellipse 5"
                  cx={1.094}
                  cy={1.23}
                  rx={1.094}
                  ry={1.23}
                  transform="translate(11.423 11.166)"
                  fill="#f5ad49"
                />
                <path
                  data-name="Path 25"
                  d="M13.482 17.208a.944.944 0 10.943-.943.944.944 0 00-.943.943z"
                  fill="#fff"
                />
                <path
                  data-name="Path 26"
                  d="M9.965 17.208a.944.944 0 10.944-.943.944.944 0 00-.944.943z"
                  fill="#fff"
                />
                <g data-name="Group 15" transform="translate(18.808 65.224)">
                  <rect
                    data-name="Rectangle 30"
                    width={38.602}
                    height={5.839}
                    rx={1.89}
                    transform="translate(0 .696)"
                    fill="#374c7f"
                  />
                  <rect
                    data-name="Rectangle 31"
                    width={38.602}
                    height={5.839}
                    rx={1.89}
                    fill="#ff4747"
                  />
                </g>
                <g data-name="Group 16" fill="#f5ad49">
                  <path
                    data-name="Path 27"
                    d="M37.293 44.593l-.748 1.516-1.673.243 1.21 1.18-.286 1.666 1.5-.787 1.5.787-.286-1.666 1.21-1.18-1.673-.243z"
                  />
                  <path
                    data-name="Path 28"
                    d="M31.986 44.593l-.748 1.516-1.673.243 1.21 1.18-.286 1.666 1.5-.787 1.5.787-.286-1.666 1.21-1.18-1.673-.243z"
                  />
                  <path
                    data-name="Path 29"
                    d="M26.68 44.593l-.748 1.516-1.673.243 1.21 1.18-.286 1.666 1.5-.787 1.5.787-.286-1.666 1.21-1.18-1.673-.243z"
                  />
                  <path
                    data-name="Path 30"
                    d="M21.374 44.593l-.748 1.516-1.673.243 1.21 1.18-.286 1.666 1.5-.787 1.5.787-.286-1.666 1.21-1.18-1.673-.243z"
                  />
                  <path
                    data-name="Path 31"
                    d="M16.067 44.593l-.748 1.516-1.673.243 1.21 1.18-.286 1.666 1.5-.787 1.5.787-.286-1.666 1.21-1.18-1.673-.243z"
                  />
                </g>
                <g data-name="Group 22" transform="translate(13.155 54.588)">
                  <rect
                    data-name="Rectangle 32"
                    width={47.934}
                    height={7.25}
                    rx={2.347}
                    fill="#f5ad49"
                  />
                  <g data-name="Group 21" fill="#374c7f">
                    <g data-name="Group 17">
                      <path
                        data-name="Rectangle 33"
                        d="M13.097 1.368h.856v4.515h-.856z"
                      />
                      <path
                        data-name="Rectangle 34"
                        d="M11.267 3.198h4.515v.856h-4.515z"
                      />
                      <path
                        data-name="Rectangle 35"
                        d="M12.231 5.524l-.605-.605 3.192-3.193.606.605z"
                      />
                      <path
                        data-name="Rectangle 36"
                        d="M14.818 5.524l-3.193-3.193.606-.605 3.192 3.193z"
                      />
                    </g>
                    <g data-name="Group 18">
                      <path
                        data-name="Rectangle 37"
                        d="M20.313 1.368h.855v4.515h-.855z"
                      />
                      <path
                        data-name="Rectangle 38"
                        d="M18.483 3.198h4.515v.856h-4.515z"
                      />
                      <path
                        data-name="Rectangle 39"
                        d="M19.447 5.524l-.605-.605 3.193-3.193.605.606z"
                      />
                      <path
                        data-name="Rectangle 40"
                        d="M22.035 5.524l-3.193-3.192.605-.606L22.64 4.92z"
                      />
                    </g>
                    <g data-name="Group 19">
                      <path
                        data-name="Rectangle 41"
                        d="M27.529 1.368h.856v4.515h-.856z"
                      />
                      <path
                        data-name="Rectangle 42"
                        d="M25.699 3.198h4.515v.856h-4.515z"
                      />
                      <path
                        data-name="Rectangle 43"
                        d="M26.663 5.524l-.605-.605 3.192-3.193.606.605z"
                      />
                      <path
                        data-name="Rectangle 44"
                        d="M29.25 5.524l-3.193-3.193.606-.605 3.192 3.193z"
                      />
                    </g>
                    <g data-name="Group 20">
                      <path
                        data-name="Rectangle 45"
                        d="M34.745 1.368h.855v4.515h-.855z"
                      />
                      <path
                        data-name="Rectangle 46"
                        d="M32.915 3.198h4.515v.856h-4.515z"
                      />
                      <path
                        data-name="Rectangle 47"
                        d="M33.879 5.524l-.605-.605 3.193-3.193.605.606z"
                      />
                      <path
                        data-name="Rectangle 48"
                        d="M36.467 5.524l-3.192-3.192.605-.605 3.192 3.192z"
                      />
                    </g>
                  </g>
                </g>
                <circle
                  data-name="Ellipse 11"
                  cx={1.569}
                  cy={1.569}
                  transform="translate(111.901 2.258)"
                  fill="#374c7f"
                  r={1.569}
                />
                <circle
                  data-name="Ellipse 12"
                  cx={1.569}
                  cy={1.569}
                  transform="translate(105.596 2.258)"
                  fill="#ff4747"
                  r={1.569}
                />
                <circle
                  data-name="Ellipse 13"
                  cx={1.569}
                  cy={1.569}
                  transform="translate(99.292 2.258)"
                  fill="#fff"
                  r={1.569}
                />
                <path
                  data-name="Line 11"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.538}
                  d="M61.089 26.767H13.155"
                />
                <path
                  data-name="Line 12"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.538}
                  d="M61.089 33.709H13.155"
                />
                <path
                  data-name="Line 13"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.538}
                  d="M61.089 40.651H13.155"
                />
                <path
                  data-name="Line 14"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.538}
                  d="M61.089 47.593H43.01"
                />
              </g>
            </g>
            <g data-name="Group 38" transform="translate(259.868 167.043)">
              <rect
                data-name="Rectangle 49"
                width={161.116}
                height={104.522}
                rx={9.739}
                transform="translate(3.306 3.967)"
                fill="#374c7f"
              />
              <g data-name="Group 37">
                <rect
                  data-name="Rectangle 50"
                  width={161.116}
                  height={104.522}
                  rx={8.999}
                  fill="#bcc0ce"
                />
                <path
                  data-name="Path 42"
                  d="M7.275 101.685h146.756a4.076 4.076 0 004.075-4.076V12.935a3.193 3.193 0 00-3.193-3.193H6.396a3.194 3.194 0 00-3.193 3.193v84.674a4.076 4.076 0 004.072 4.076z"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 51"
                  width={149.824}
                  height={15.354}
                  rx={7.677}
                  transform="translate(5.38 12.287)"
                  fill="#374c7f"
                />
                <rect
                  data-name="Rectangle 52"
                  width={92.405}
                  height={5.843}
                  rx={2.121}
                  transform="translate(32.697 16.734)"
                  fill="#fff"
                />
                <rect
                  data-name="Rectangle 53"
                  width={29.491}
                  height={5.843}
                  rx={1.962}
                  transform="translate(120.352 16.734)"
                  fill="#def6f8"
                />
                <path
                  data-name="Line 15"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={1.021}
                  d="M117.089 19.655H86.728"
                />
                <path
                  data-name="Line 16"
                  fill="none"
                  stroke="#57595e"
                  strokeMiterlimit={10}
                  strokeWidth={1.021}
                  d="M145.839 19.655h-20.736"
                />
                <path
                  data-name="Path 43"
                  d="M34.168 16.734h9.085v5.843h-9.085a1.475 1.475 0 01-1.475-1.475v-2.894a1.474 1.474 0 011.475-1.474z"
                  fill="#f5ad49"
                />
                <g
                  data-name="Group 26"
                  transform="translate(36.339 17.549)"
                  fill="none"
                  stroke="#fff"
                  strokeMiterlimit={10}
                  strokeWidth={0.681}
                >
                  <circle
                    data-name="Ellipse 14"
                    cx={1.538}
                    cy={1.538}
                    transform="translate(1.288)"
                    r={1.538}
                  />
                  <path data-name="Line 17" d="M1.639 2.516L0 4.155" />
                </g>
                <path
                  data-name="Path 44"
                  d="M25.375 15.61h-3.448l-1.655 4.875h-7.063l-.762-3.847"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={1.521}
                />
                <ellipse
                  data-name="Ellipse 15"
                  cx={1.476}
                  cy={1.66}
                  rx={1.476}
                  ry={1.66}
                  transform="translate(15.412 15.065)"
                  fill="#f5ad49"
                />
                <circle
                  data-name="Ellipse 16"
                  cx={1.273}
                  cy={1.273}
                  transform="translate(18.189 21.944)"
                  fill="#fff"
                  r={1.273}
                />
                <circle
                  data-name="Ellipse 17"
                  cx={1.273}
                  cy={1.273}
                  transform="translate(13.444 21.944)"
                  fill="#fff"
                  r={1.273}
                />
                <g data-name="Group 27">
                  <path
                    data-name="Rectangle 54"
                    d="M27.924 88.935h46.981a2.55 2.55 0 012.55 2.55v2.778a2.55 2.55 0 01-2.55 2.55h-46.98a2.55 2.55 0 01-2.55-2.55v-2.779a2.549 2.549 0 012.549-2.549z"
                    fill="#374c7f"
                  />
                  <path
                    data-name="Rectangle 55"
                    d="M27.924 87.996h46.981a2.549 2.549 0 012.549 2.549v2.779a2.55 2.55 0 01-2.55 2.55h-46.98a2.549 2.549 0 01-2.549-2.55v-2.779a2.549 2.549 0 012.549-2.549z"
                    fill="#ff4747"
                  />
                </g>
                <g data-name="Group 28" fill="#f5ad49">
                  <path
                    data-name="Path 45"
                    d="M50.313 60.162l-1.009 2.045-2.257.328 1.633 1.592-.385 2.248 2.018-1.061 2.018 1.061-.385-2.248 1.633-1.592-2.257-.328z"
                  />
                  <path
                    data-name="Path 46"
                    d="M43.155 60.162l-1.009 2.045-2.257.328 1.633 1.592-.385 2.248 2.018-1.061 2.018 1.061-.385-2.248 1.633-1.592-2.257-.328z"
                  />
                  <path
                    data-name="Path 47"
                    d="M35.995 60.162l-1.009 2.045-2.257.328 1.633 1.592-.385 2.248 2.018-1.061 2.018 1.061-.386-2.248 1.633-1.592-2.257-.328z"
                  />
                  <path
                    data-name="Path 48"
                    d="M28.835 60.162l-1.009 2.045-2.257.328 1.633 1.592-.386 2.248 2.018-1.061 2.018 1.061-.385-2.248 1.633-1.592-2.257-.328z"
                  />
                  <path
                    data-name="Path 49"
                    d="M21.676 60.162l-1.009 2.045-2.257.328 1.633 1.592-.385 2.248 2.018-1.061 2.018 1.061-.386-2.248 1.633-1.592-2.257-.328z"
                  />
                </g>
                <g data-name="Group 34" transform="translate(17.749 73.647)">
                  <rect
                    data-name="Rectangle 56"
                    width={64.67}
                    height={9.782}
                    rx={3.166}
                    fill="#f5ad49"
                  />
                  <g data-name="Group 33" fill="#374c7f">
                    <g data-name="Group 29">
                      <path
                        data-name="Rectangle 57"
                        d="M17.669 1.845h1.154v6.092h-1.154z"
                      />
                      <path
                        data-name="Rectangle 58"
                        d="M15.2 4.314h6.092v1.154H15.2z"
                      />
                      <path
                        data-name="Rectangle 59"
                        d="M16.5 7.453l-.816-.816 4.308-4.308.816.816z"
                      />
                      <path
                        data-name="Rectangle 60"
                        d="M19.991 7.453l-4.308-4.308.816-.816 4.308 4.308z"
                      />
                    </g>
                    <g data-name="Group 30">
                      <path
                        data-name="Rectangle 61"
                        d="M27.404 1.845h1.154v6.092h-1.154z"
                      />
                      <path
                        data-name="Rectangle 62"
                        d="M24.935 4.314h6.092v1.154h-6.092z"
                      />
                      <path
                        data-name="Rectangle 63"
                        d="M26.235 7.453l-.816-.816 4.308-4.308.816.816z"
                      />
                      <path
                        data-name="Rectangle 64"
                        d="M29.726 7.453l-4.308-4.308.816-.816 4.308 4.308z"
                      />
                    </g>
                    <g data-name="Group 31">
                      <path
                        data-name="Rectangle 65"
                        d="M37.14 1.845h1.154v6.092H37.14z"
                      />
                      <path
                        data-name="Rectangle 66"
                        d="M34.671 4.314h6.092v1.154h-6.092z"
                      />
                      <path
                        data-name="Rectangle 67"
                        d="M35.971 7.453l-.816-.816 4.308-4.308.816.816z"
                      />
                      <path
                        data-name="Rectangle 68"
                        d="M39.462 7.453l-4.308-4.308.816-.816 4.308 4.308z"
                      />
                    </g>
                    <g data-name="Group 32">
                      <path
                        data-name="Rectangle 69"
                        d="M46.875 1.845h1.154v6.092h-1.154z"
                      />
                      <path
                        data-name="Rectangle 70"
                        d="M44.406 4.314h6.092v1.154h-6.092z"
                      />
                      <path
                        data-name="Rectangle 71"
                        d="M45.706 7.453l-.816-.816 4.308-4.308.816.816z"
                      />
                      <path
                        data-name="Rectangle 72"
                        d="M49.197 7.453l-4.308-4.308.816-.816 4.308 4.308z"
                      />
                    </g>
                  </g>
                </g>
                <circle
                  data-name="Ellipse 18"
                  cx={2.117}
                  cy={2.117}
                  transform="translate(150.97 3.046)"
                  fill="#374c7f"
                  r={2.117}
                />
                <circle
                  data-name="Ellipse 19"
                  cx={2.117}
                  cy={2.117}
                  transform="translate(142.465 3.046)"
                  fill="#ff4747"
                  r={2.117}
                />
                <circle
                  data-name="Ellipse 20"
                  cx={2.117}
                  cy={2.117}
                  transform="translate(133.959 3.046)"
                  fill="#fff"
                  r={2.117}
                />
                <path
                  data-name="Line 18"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={2.075}
                  d="M82.419 36.112h-64.67"
                />
                <path
                  data-name="Line 19"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={2.075}
                  d="M82.419 45.478h-64.67"
                />
                <path
                  data-name="Line 20"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={2.075}
                  d="M82.419 54.844h-64.67"
                />
                <path
                  data-name="Line 21"
                  fill="none"
                  stroke="#45619b"
                  strokeLinecap="round"
                  strokeMiterlimit={10}
                  strokeWidth={2.075}
                  d="M82.418 64.209H58.027"
                />
              </g>
            </g>
          </g>
          <path
            data-name="Path 57"
            d="M25.387 289.992c0 1.037 54.427 1.877 121.565 1.877s121.564-.84 121.564-1.877-54.426-1.876-121.564-1.876-121.565.84-121.565 1.876z"
            fill="#131a2b"
          />
          <g data-name="Group 53">
            <g data-name="Group 45">
              <g data-name="Group 44">
                <g data-name="Group 41">
                  <g data-name="Group 40">
                    <path
                      data-name="Path 58"
                      d="M69.238 231.669s-24.457-59.587-47.622-43.332c-8.267 6.511 45.124 46.947 45.124 46.947z"
                      fill="#a4bdda"
                    />
                    <path
                      data-name="Path 59"
                      d="M30.128 190.925s28.468 24.357 35.913 35.787"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                    <path
                      data-name="Path 60"
                      d="M50.378 209.368s-2.014-3.564-1.749-10.511"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                    <path
                      data-name="Path 61"
                      d="M59.693 229.79l-20.229-41.145c16.365 10.36 29.774 43.022 29.774 43.022l-2.2 3.183-2.317-1.117a525.914 525.914 0 01-5.028-3.943z"
                      fill="#7590aa"
                      style={{
                        mixBlendMode: "multiply",
                        isolation: "isolate",
                      }}
                    />
                    <path
                      data-name="Path 62"
                      d="M74.639 235.41s-.237-94.929-39.517-86.815c-14.4 3.854 34.281 90.2 34.281 90.2z"
                      fill="#b4d1ed"
                    />
                    <path
                      data-name="Path 63"
                      d="M43.767 154.727s23.463 47.742 27.293 77.294"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                    <path
                      data-name="Path 64"
                      d="M36.816 163.002s9.958 3.806 13.888 6.814"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                    <path
                      data-name="Path 65"
                      d="M62.385 172.613s-3.293 9.287-3.859 16.109"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                    <path
                      data-name="Path 66"
                      d="M53.94 200.136s6.385 1.3 10.341 4.565"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.747}
                    />
                  </g>
                  <path
                    data-name="Path 67"
                    d="M41.647 201.161a35.947 35.947 0 00-13.57-1.666"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit={10}
                    strokeWidth={0.747}
                  />
                </g>
                <g data-name="Group 43">
                  <g data-name="Group 42">
                    <path
                      data-name="Path 68"
                      d="M71.064 230.869s24.216-33.6 36.266-19.964c4.194 5.309-35.246 22.6-35.246 22.6z"
                      fill="#a4bdda"
                    />
                    <path
                      data-name="Path 69"
                      d="M101.624 211.253s-21.448 10.967-27.815 17"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                    <path
                      data-name="Path 70"
                      d="M86.201 219.753s1.793-1.927 2.667-6.31"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                    <path
                      data-name="Path 71"
                      d="M77.319 231.128l18.81-22.7c-11.784 4.027-25.06 22.442-25.06 22.442l.9 2.319 1.616-.351c.91-.41 2.191-.992 3.734-1.71z"
                      fill="#7590aa"
                      style={{
                        mixBlendMode: "multiply",
                        isolation: "isolate",
                      }}
                    />
                    <path
                      data-name="Path 72"
                      d="M67.131 232.403s14.364-59.321 37.71-48.366c8.426 4.565-34.943 51.268-34.943 51.268z"
                      fill="#b4d1ed"
                    />
                    <path
                      data-name="Path 73"
                      d="M98.516 186.577s-21.82 26.339-28.64 44.243"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                    <path
                      data-name="Path 74"
                      d="M101.624 192.792s-6.8.888-9.7 2.181"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                    <path
                      data-name="Path 75"
                      d="M84.197 194.973a51.436 51.436 0 010 10.651"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                    <path
                      data-name="Path 76"
                      d="M85.356 213.446a17.794 17.794 0 00-7.149 1.306"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.48}
                    />
                  </g>
                  <path
                    data-name="Path 77"
                    d="M92.889 215.929a23.116 23.116 0 018.735.991"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit={10}
                    strokeWidth={0.48}
                  />
                </g>
                <path
                  data-name="Rectangle 74"
                  fill="#c92d3c"
                  d="M54.351 230.419h33.183v58.732H54.351z"
                />
              </g>
              <path
                data-name="Rectangle 75"
                fill="#ff4747"
                d="M54.351 240.187h33.183v17.993H54.351z"
              />
            </g>
            <g data-name="Group 51">
              <g data-name="Group 50">
                <g data-name="Group 47">
                  <g data-name="Group 46">
                    <path
                      data-name="Path 78"
                      d="M117.691 242.856s19.126-46.6 37.243-33.887c6.464 5.092-35.289 36.714-35.289 36.714z"
                      fill="#a4bdda"
                    />
                    <path
                      data-name="Path 79"
                      d="M148.276 210.99s-22.264 19.048-28.085 27.987"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                    <path
                      data-name="Path 80"
                      d="M132.44 225.414s1.575-2.787 1.368-8.22"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                    <path
                      data-name="Path 81"
                      d="M125.156 241.386l15.819-32.177c-12.8 8.1-23.285 33.645-23.285 33.645l1.72 2.489 1.812-.873c.961-.745 2.313-1.8 3.934-3.084z"
                      fill="#7590aa"
                      style={{
                        mixBlendMode: "multiply",
                        isolation: "isolate",
                      }}
                    />
                    <path
                      data-name="Path 82"
                      d="M113.467 245.779s.186-74.238 30.9-67.893c11.26 3.014-26.809 70.541-26.809 70.541z"
                      fill="#b4d1ed"
                    />
                    <path
                      data-name="Path 83"
                      d="M137.61 182.682s-18.349 37.333-21.344 60.447"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                    <path
                      data-name="Path 84"
                      d="M143.046 189.153s-7.788 2.976-10.861 5.329"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                    <path
                      data-name="Path 85"
                      d="M123.05 196.67s2.575 7.263 3.017 12.6"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                    <path
                      data-name="Path 86"
                      d="M129.655 218.194s-4.994 1.016-8.087 3.569"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.584}
                    />
                  </g>
                  <path
                    data-name="Path 87"
                    d="M139.268 218.996a28.1 28.1 0 0110.613-1.3"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit={10}
                    strokeWidth={0.584}
                  />
                </g>
                <g data-name="Group 49">
                  <g data-name="Group 48">
                    <path
                      data-name="Path 88"
                      d="M116.259 242.23s-18.938-26.274-28.361-15.612c-3.28 4.153 27.563 17.672 27.563 17.672z"
                      fill="#a4bdda"
                    />
                    <path
                      data-name="Path 89"
                      d="M92.365 226.888s16.773 8.577 21.752 13.294"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                    <path
                      data-name="Path 90"
                      d="M104.426 233.535a10.661 10.661 0 01-2.086-4.935"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                    <path
                      data-name="Path 91"
                      d="M111.372 242.43l-14.71-17.75c9.215 3.149 19.6 17.551 19.6 17.551l-.7 1.814-1.263-.275c-.718-.321-1.721-.777-2.927-1.34z"
                      fill="#7590aa"
                      style={{
                        mixBlendMode: "multiply",
                        isolation: "isolate",
                      }}
                    />
                    <path
                      data-name="Path 92"
                      d="M119.339 243.429s-11.233-46.391-29.49-37.824c-6.59 3.571 27.326 40.093 27.326 40.093z"
                      fill="#b4d1ed"
                    />
                    <path
                      data-name="Path 93"
                      d="M94.794 207.59s17.065 20.6 22.4 34.6"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                    <path
                      data-name="Path 94"
                      d="M92.364 212.45s5.315.7 7.589 1.705"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                    <path
                      data-name="Path 95"
                      d="M105.993 214.156a40.2 40.2 0 000 8.329"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                    <path
                      data-name="Path 96"
                      d="M105.086 228.604a13.921 13.921 0 015.591 1.021"
                      fill="none"
                      stroke="#fff"
                      strokeMiterlimit={10}
                      strokeWidth={0.376}
                    />
                  </g>
                  <path
                    data-name="Path 97"
                    d="M99.194 230.544a18.066 18.066 0 00-6.83.774"
                    fill="none"
                    stroke="#fff"
                    strokeMiterlimit={10}
                    strokeWidth={0.376}
                  />
                </g>
                <path
                  data-name="Rectangle 76"
                  fill="#c92d3c"
                  d="M103.383 241.876h25.95v45.93h-25.95z"
                />
              </g>
              <path
                data-name="Rectangle 77"
                fill="#ff4747"
                d="M103.383 249.515h25.95v14.071h-25.95z"
              />
            </g>
            <g data-name="Group 52">
              <path
                data-name="Path 98"
                d="M105.797 136.398h.246a12.187 12.187 0 0112.187 12.187v13.514H93.61v-13.514a12.187 12.187 0 0112.187-12.187z"
                fill="none"
                stroke="#ce7a2e"
                strokeMiterlimit={10}
                strokeWidth={2.415}
              />
              <path
                data-name="Path 99"
                d="M101.678 136.398h.246a12.187 12.187 0 0112.188 12.187v13.514H89.488v-13.514a12.187 12.187 0 0112.19-12.187z"
                fill="none"
                stroke="#ce7a2e"
                strokeMiterlimit={10}
                strokeWidth={2.415}
              />
              <path
                data-name="Rectangle 78"
                fill="#374c7f"
                d="M66.75 234.84h80.577v54.837H66.75z"
              />
              <path
                data-name="Rectangle 79"
                fill="#28355f"
                d="M116.551 234.84h30.776v54.837h-30.776z"
              />
              <path
                data-name="Rectangle 80"
                fill="#ff4747"
                d="M74.024 209.66h57.915v25.18H74.024z"
              />
              <path
                data-name="Rectangle 81"
                fill="#bc3535"
                d="M74.024 209.66H91.93v25.18H74.024z"
              />
              <path
                data-name="Path 100"
                d="M83.258 158.739h40.845l2.52 50.92H80.739z"
                fill="#f5ad49"
              />
              <path
                data-name="Path 101"
                d="M131.939 234.84L91.93 224.705 74.024 234.84z"
                fill="#400"
                opacity={0.53}
                style={{
                  mixBlendMode: "multiply",
                  isolation: "isolate",
                }}
              />
              <path
                data-name="Path 102"
                d="M126.623 209.659s-26.507-10.14-29.567-50.92h-13.8l-2.519 50.92z"
                fill="#e37427"
              />
            </g>
          </g>
          <g data-name="Group 54">
            <path
              data-name="Rectangle 82"
              fill="#e37427"
              d="M217.455 154.197h11.308v20.399h-11.308z"
            />
            <path
              data-name="Path 104"
              d="M213.135 272.737s.387 4.317-4.5 4.636"
              fill="none"
              stroke="#a50000"
              strokeMiterlimit={10}
              strokeWidth={0.92}
            />
            <path
              data-name="Path 106"
              d="M171.48 231.764l-1.4 57.914h25.557a6.973 6.973 0 00-4.426-7.673v-50.241z"
              fill="#ff8076"
            />
            <path
              data-name="Path 107"
              d="M171.481 231.763h19.729v4.844c-5.35 5.635-14.443 6.534-20 6.492z"
              fill="#400"
            />
            <path
              data-name="Path 108"
              d="M181.637 231.763h9.577v50.242a6.973 6.973 0 014.426 7.673h-12.678z"
              fill="#fff"
              opacity={0.42}
              style={{
                mixBlendMode: "overlay",
                isolation: "isolate",
              }}
            />
            <path
              data-name="Path 110"
              d="M219.321 276.359h.268a5.517 5.517 0 015.517 5.516v.129h-11.3v-.129a5.517 5.517 0 015.515-5.516z"
              fill="#28355f"
            />
            <path
              data-name="Path 111"
              d="M230.614 289.678h-25.46l-.867-7.673h21.08c5.739 1.467 5.247 7.673 5.247 7.673z"
              fill="#394c77"
            />
            <path
              data-name="Path 112"
              d="M197.563 165.413l4.032 116.466s7.522 5.586 18.659-5.208l-10.242-114.26z"
              fill="#374c7f"
            />
            <path
              data-name="Path 113"
              d="M209.553 283.325a18.074 18.074 0 01-7.28-2.028l-7.766-118.114h7.763z"
              fill="#28355f"
            />
            <path
              data-name="Path 114"
              d="M214.707 283.184a1.179 1.179 0 001.179 1.179h8.942a1.179 1.179 0 001.18-1.179 1.179 1.179 0 00-1.18-1.179h-8.942a1.179 1.179 0 00-1.179 1.179z"
              fill="#fff"
            />
            <path
              data-name="Path 115"
              d="M195.635 289.678h-25.558l.186-7.673h20.946a6.973 6.973 0 014.426 7.673z"
              fill="#394c77"
            />
            <path
              data-name="Path 116"
              d="M179.909 283.184a1.179 1.179 0 001.18 1.179h8.942a1.179 1.179 0 001.179-1.179 1.179 1.179 0 00-1.179-1.179h-8.942a1.179 1.179 0 00-1.18 1.179z"
              fill="#fff"
            />
            <path
              data-name="Path 117"
              d="M185.426 276.359h.268a5.516 5.516 0 015.516 5.516v.129h-11.3v-.129a5.517 5.517 0 015.516-5.516z"
              fill="#28355f"
            />
            <path
              data-name="Path 118"
              d="M178.005 272.737s.387 4.317-4.5 4.636"
              fill="none"
              stroke="#a50000"
              strokeMiterlimit={10}
              strokeWidth={0.92}
            />
            <path
              data-name="Path 119"
              d="M173.894 163.674l-4.888 116.274s9.045 7.6 24.072 0v-82.583s5.74-15.317 4.789-28.982l-.633-8.509z"
              fill="#374c7f"
            />
            <path
              data-name="Path 120"
              d="M174.967 283.184a16.017 16.017 0 01-5.961-2.778l4.889-117.878 4.111-.679z"
              fill="#28355f"
            />
            <path
              data-name="Path 121"
              d="M178.006 161.849l8.481-.871c-.232 4.8-1.612 15.485-9.2 18.739z"
              fill="#28355f"
            />
            <path
              data-name="Path 122"
              d="M173.36 170.347l.538-8.076 23.339-2.4.422 3.582 9.969-1.184s-11.257 10.24-34.268 8.078z"
              fill="#072847"
            />
            <path
              data-name="Path 123"
              d="M200.107 96.091s5.435 1.119 9.272 14.547 8.44 30.053 8.44 30.053 31.528-1.813 34.088 11.087h-48.49z"
              fill="#fccfb8"
            />
            <path
              data-name="Path 124"
              d="M213.182 124.062a40.667 40.667 0 01-11.261 2.533l-1.81-30.5s5.435 1.119 9.272 14.547c1.247 4.361 2.574 9.061 3.799 13.42z"
              fill="#bc3535"
            />
            <path
              data-name="Path 125"
              d="M205.716 119.063l5.359 28.341h-3.81z"
              fill="#400"
            />
            <path
              data-name="Path 126"
              d="M179.39 91.855l-13.965 13.028 8.473 57.388s23.541 7.353 36.969 0c-.959-37.407-3.657-44.955-10.752-66.181-13.364-4.554-14.248-4.236-14.248-4.236z"
              fill="#ff4747"
            />
            <path
              data-name="Path 127"
              d="M180.049 78.262l-.659 13.593 8.923 13.028 1.437-10.631-.882-8.073-6.129-8.153z"
              fill="#fccfb8"
            />
            <path
              data-name="Path 128"
              d="M181.976 80.385l2.169-.489 4.724 6.282.882 8.073c-6.605-4.394-7.775-13.866-7.775-13.866z"
              fill="#400"
            />
            <path
              data-name="Path 129"
              d="M193.344 72.912s6.448 0 7.487-4.955c.4-1.758-2.618-3.917-5.186-1.6 1.349-4.8-.1-5.994-3.413-5.994s-6.269 5.355-6.348 5.6c-.4-3.757-3.677-4-4.317 1.119-2.878 1.519-4.887 1.94-4.682 6.235s1.565 10.5 3 11.883l.014-.009a3.4 3.4 0 001.639-2.486l.353-2.706 1.252-2.787 4.187-5.414z"
              fill="#7a0000"
            />
            <path
              data-name="Path 130"
              d="M184.594 70.083s7.856-5.229 8.751-9.663c2.506.285 3.487 1.719 2.3 5.937 2.567-2.318 5.585-.159 5.186 1.6-1.039 4.959-7.487 4.959-7.487 4.959l-4.019-.748z"
              fill="#fff"
              opacity={0.42}
              style={{
                mixBlendMode: "overlay",
                isolation: "isolate",
              }}
            />
            <path
              data-name="Path 131"
              d="M194.495 71.962a149.358 149.358 0 011.15 15.1 4.129 4.129 0 01-6 3.713c-3.884-2.018-7.2-5.415-8.075-12.848l1.172.106-.32-7.46s5.548-1.479 9.618-1.049a2.781 2.781 0 012.455 2.438z"
              fill="#fccfb8"
            />
            <path
              data-name="Path 132"
              d="M182.74 78.027l-.114-2.659s.434 5 2.672 6.815 5.989.869 8.1.853c.767-.006 1.5.027 2.115.071.073 1.347.122 2.684.132 3.947a4.13 4.13 0 01-6 3.714c-3.883-2.018-7.2-5.415-8.073-12.848z"
              fill="#7a0000"
            />
            <path
              data-name="Path 133"
              d="M187.333 78.318a.453.453 0 00.49.4.453.453 0 00.49-.4v-1.287a.453.453 0 00-.49-.4.453.453 0 00-.49.4z"
              fill="#7a0000"
            />
            <path
              data-name="Path 134"
              d="M193.343 79.108a.45.45 0 00.489.4.45.45 0 00.49-.4v-1.266a.451.451 0 00-.49-.4.45.45 0 00-.489.4z"
              fill="#7a0000"
            />
            <path
              data-name="Path 135"
              d="M191.84 78.262l.392 4.246h-2.025"
              fill="none"
              stroke="#ba4a4a"
              strokeMiterlimit={10}
              strokeWidth={0.46}
            />
            <path
              data-name="Path 136"
              d="M193.344 84.272h-4.312a3.074 3.074 0 004.312 0z"
              fill="#fff"
            />
            <path
              data-name="Path 137"
              d="M178.051 117.032l3.517 26.514-13.309 3.859z"
              fill="#400"
            />
            <path
              data-name="Path 138"
              d="M181.568 77.92l-.56-3.186s-4.636-1.583-4.076 2.333c.48 2.718 4.962 2.925 4.962 2.925z"
              fill="#fccfb8"
            />
            <path
              data-name="Path 139"
              d="M183.146 97.335l-2.4 9.275-3.931-12.363 2.571-2.4z"
              fill="#bc3535"
            />
            <path
              data-name="Path 140"
              d="M189.076 99.234l4.266 4.172-1.774-10.108-1.988-.592.169 1.546z"
              fill="#bc3535"
            />
            <path
              data-name="Path 141"
              d="M184.594 70.083a27.328 27.328 0 017.444-.565 2.781 2.781 0 012.457 2.44 149.34 149.34 0 011.15 15.1 4.143 4.143 0 01-4.626 4.137c-.587-.832-1.446-2.117-2.706-4.118-2.986-4.742-3.605-14.426-3.719-16.994z"
              fill="#fff"
              opacity={0.42}
              style={{
                mixBlendMode: "overlay",
                isolation: "isolate",
              }}
            />
            <path
              data-name="Path 142"
              d="M189.75 74.865s-1.764-1.633-3.527-.457"
              fill="none"
              stroke="#7a0000"
              strokeLinecap="round"
              strokeMiterlimit={10}
              strokeWidth={1.84}
            />
            <path
              data-name="Path 143"
              d="M193.016 74.866s1.5-.587 2.351 0"
              fill="none"
              stroke="#7a0000"
              strokeLinecap="round"
              strokeMiterlimit={10}
              strokeWidth={1.84}
            />
            <path
              data-name="Line 22"
              fill="none"
              stroke="#a50000"
              strokeMiterlimit={10}
              strokeWidth={0.92}
              d="M181.675 78.719l-3.624-2.09"
            />
            <path
              data-name="Line 23"
              fill="none"
              stroke="#80c8d4"
              strokeMiterlimit={10}
              strokeWidth={0.92}
              d="M178.051 170.347l-3.078 112.016"
            />
            <path
              data-name="Rectangle 83"
              fill="#f5ad49"
              d="M220.274 174.596h5.101v115.081h-5.101z"
            />
            <path
              data-name="Rectangle 84"
              fill="#e37427"
              style={{
                mixBlendMode: "multiply",
                isolation: "isolate",
              }}
              d="M217.455 156.621h11.308v3.253h-11.308z"
            />
            <path
              data-name="Rectangle 85"
              fill="#e37427"
              d="M203.008 287.157h40.542v2.52h-40.542z"
            />
            <path
              data-name="Rectangle 86"
              fill="#f5ad49"
              d="M181.894 151.774h82.16v4.846h-82.16z"
            />
            <path
              data-name="Rectangle 87"
              fill="#fff"
              d="M206.214 147.405h33.222v4.369h-33.222z"
            />
            <path
              data-name="Rectangle 88"
              fill="#28355f"
              d="M239.436 147.405h23.561v4.369h-23.561z"
            />
            <path
              data-name="Path 144"
              d="M261.544 116.447h23.561l-23.561 30.958h-23.561z"
              fill="#374c7f"
            />
            <path
              data-name="Path 145"
              d="M262.997 116.447h23.561l-23.561 30.958h-23.561z"
              fill="#fff"
            />
            <path
              data-name="Path 146"
              d="M202.03 151.775l-10.317 4.846h-8.223l12.5-4.846z"
              fill="#e37427"
            />
            <path
              data-name="Path 147"
              d="M262.384 131.21c-2.26.964-3.631 2.827-3.062 4.162s2.863 1.636 5.124.672 3.632-2.827 3.062-4.162-2.863-1.636-5.124-.672z"
              fill="#def6f8"
            />
            <path
              data-name="Rectangle 89"
              fill="#374c7f"
              d="M228.763 148.464h7.61v2.093h-7.61z"
            />
            <path
              data-name="Rectangle 90"
              fill="#374c7f"
              d="M219.02 148.464h7.61v2.093h-7.61z"
            />
            <path
              data-name="Path 148"
              d="M165.422 104.883s-2.718 4.476-3.144 15.772c-.25 6.621-.207 20.9-.129 31.585a9.289 9.289 0 0012.563 8.623l31.5-13.459h11.609s2.43-2.878-5.456-4.8a90.258 90.258 0 00-9.673-1.748 32.461 32.461 0 00-11.057.486l-13.587 2.967v-27.277s-.104-10.017-12.626-12.149z"
              fill="#fccfb8"
            />
            <path
              data-name="Path 149"
              d="M162.279 120.655c.426-11.3 3.144-15.772 3.144-15.772 12.522 2.132 12.629 12.149 12.629 12.149v16.212a65.873 65.873 0 01-15.946-1.974c.023-4.26.075-8.024.173-10.615z"
              fill="#bc3535"
            />
            <path
              data-name="Line 25"
              fill="none"
              stroke="#a50000"
              strokeLinecap="round"
              strokeMiterlimit={10}
              strokeWidth={0.92}
              d="M178.051 144.314l-6.57 1.605"
            />
            <path
              data-name="Path 151"
              d="M217.458 144.866s-7.538-2.1-11.242-1.778"
              fill="none"
              stroke="#a50000"
              strokeLinecap="round"
              strokeMiterlimit={10}
              strokeWidth={0.92}
            />
          </g>
        </g>
        <g data-name="light-bulb (2)">
          <path
            data-name="Path 1012"
            d="M335.975 92.135v.011a3.24 3.24 0 106.48 0v-.011z"
            fill="#165a9f"
          />
          <path
            data-name="Path 1013"
            d="M342.253 92.147h-6.075a1.823 1.823 0 010-3.645h6.075a1.823 1.823 0 110 3.645z"
            fill="#003586"
          />
          <path
            data-name="Path 1014"
            d="M338.608 92.147h-2.43a1.823 1.823 0 110-3.645h2.43a1.823 1.823 0 000 3.645z"
            fill="#456b93"
          />
          <path
            data-name="Path 1015"
            d="M342.253 88.502h-6.075a1.823 1.823 0 010-3.645h6.075a1.823 1.823 0 110 3.645z"
            fill="#003586"
          />
          <path
            data-name="Path 1016"
            d="M338.608 88.502h-2.43a1.823 1.823 0 010-3.645h2.43a1.823 1.823 0 000 3.645z"
            fill="#456b93"
          />
          <path
            data-name="Path 1017"
            d="M350.271 70.156a11.056 11.056 0 10-17.78 8.777 4.816 4.816 0 011.864 3.827 2.1 2.1 0 002.1 2.1h5.524a2.1 2.1 0 002.1-2.1 4.9 4.9 0 011.915-3.866 11.036 11.036 0 004.277-8.738z"
            fill="#ffe177"
          />
          <path
            data-name="Path 1018"
            d="M337.399 84.243a2.093 2.093 0 001.483.614h-2.43a2.1 2.1 0 01-2.1-2.1 4.815 4.815 0 00-1.864-3.827 11.056 11.056 0 016.856-19.832c.366 0 .728.027 1.085.066a11.056 11.056 0 00-5.511 19.766 4.815 4.815 0 011.864 3.827 2.093 2.093 0 00.617 1.486z"
            fill="#ffc85e"
          />
          <g data-name="Group 122">
            <path
              data-name="Path 1019"
              d="M329.133 72.913a10.593 10.593 0 018.831-13.131.608.608 0 00-.146-1.206 11.808 11.808 0 00-9.858 14.656q.284.546.746.427a.608.608 0 00.427-.746z"
            />
            <path
              data-name="Path 1020"
              d="M340.61 58.575a.608.608 0 10-.144 1.207 10.449 10.449 0 015.151 18.63 5.551 5.551 0 00-2.15 4.346 1.638 1.638 0 01-1.823 1.49V72.732h1.349a2.552 2.552 0 100-5.1h-.013a2.554 2.554 0 00-2.552 2.552v1.337h-2.43V70.18a2.554 2.554 0 00-2.552-2.552h-.013a2.552 2.552 0 000 5.1h1.349v11.52a1.636 1.636 0 01-1.823-1.49 5.452 5.452 0 00-2.1-4.309 10.426 10.426 0 01-2.775-3.209.608.608 0 10-1.061.592 11.635 11.635 0 003.1 3.581 4.23 4.23 0 011.619 3.343 2.888 2.888 0 00.911 2.024 2.583 2.583 0 00-.911 1.9 2.424 2.424 0 00.824 1.822 2.594 2.594 0 00-.824 1.823 2.438 2.438 0 001.651 2.3 3.847 3.847 0 007.633 0 2.581 2.581 0 001.651-2.3 2.424 2.424 0 00-.824-1.822 2.592 2.592 0 00.824-1.823 2.426 2.426 0 00-.913-1.9 2.7 2.7 0 00.913-2.024 4.388 4.388 0 011.68-3.386 11.664 11.664 0 00-5.752-20.8zm1.032 11.605a1.338 1.338 0 011.337-1.337h.013a1.337 1.337 0 010 2.673h-1.35zm-6.209 1.337a1.337 1.337 0 010-2.673h.013a1.338 1.338 0 011.337 1.337v1.337zm2.564 1.215h2.43v11.516h-2.43zm1.215 22.047a2.637 2.637 0 01-2.561-2.025h5.122a2.637 2.637 0 01-2.558 2.025zm3.038-9.315a1.215 1.215 0 110 2.43h-.877a.608.608 0 000 1.215h.877a1.216 1.216 0 011.215 1.215 1.257 1.257 0 01-1.215 1.215h-6.075a1.215 1.215 0 010-2.43h2.55a.608.608 0 000-1.215h-2.55a1.215 1.215 0 010-2.43z"
            />
          </g>
          <path
            data-name="Path 1021"
            d="M339.215 57.347a.607.607 0 01-.607-.608v-1.7a.608.608 0 111.215 0v1.7a.607.607 0 01-.608.608z"
          />
          <g data-name="Group 123">
            <path
              data-name="Path 1022"
              d="M329.822 61.234a.606.606 0 01-.43-.178l-1.2-1.2a.608.608 0 01.859-.859l1.2 1.2a.608.608 0 01-.43 1.037z"
            />
            <path
              data-name="Path 1023"
              d="M349.811 81.228a.606.606 0 01-.43-.178l-1.2-1.2a.608.608 0 01.859-.859l1.2 1.2a.607.607 0 01-.43 1.037z"
            />
          </g>
          <g data-name="Group 124">
            <path
              data-name="Path 1024"
              d="M325.931 70.631h-1.7a.608.608 0 010-1.215h1.7a.608.608 0 110 1.215z"
            />
            <path
              data-name="Path 1025"
              d="M354.201 70.631h-1.7a.608.608 0 010-1.215h1.7a.608.608 0 010 1.215z"
            />
          </g>
          <g data-name="Group 125">
            <path
              data-name="Path 1026"
              d="M328.619 81.228a.608.608 0 01-.43-1.037l1.2-1.2a.608.608 0 01.859.859l-1.2 1.2a.606.606 0 01-.429.178z"
            />
            <path
              data-name="Path 1027"
              d="M348.608 61.234a.607.607 0 01-.43-1.037l1.2-1.2a.608.608 0 01.859.859l-1.2 1.2a.606.606 0 01-.429.178z"
            />
          </g>
        </g>
        <g data-name="020-lamp-19">
          <path
            data-name="Path 2079"
            d="M125.211 84.373v11.623h3.059V81.315a3.059 3.059 0 10-6.117 0v14.681h3.059zm0 0"
            fill="#ffd200"
          />
          <g data-name="Group 172" fill="#003586">
            <path
              data-name="Path 2080"
              d="M128.269 95.995h-9.783l1.223 7.341h11.007l1.224-7.341zm0 0"
            />
            <path
              data-name="Path 2081"
              d="M122.156 103.336h6.117v2.447h-6.117zm0 0"
            />
            <path
              data-name="Path 2082"
              d="M122.156 108.229h6.117v2.447h-6.117zm0 0"
            />
            <path
              data-name="Path 2083"
              d="M122.156 105.782h6.117v2.447h-6.117zm0 0"
            />
          </g>
          <path
            data-name="Path 2084"
            d="M120.933 95.995h8.56v7.341h-8.56zm0 0"
            fill="#003586"
          />
          <path
            data-name="Path 2085"
            d="M122.156 95.995h6.117v7.341h-6.117zm0 0"
            fill="#165a9f"
          />
          <path
            data-name="Path 2086"
            d="M124.6 82.538h1.223a1.223 1.223 0 011.223 1.223v12.235h-3.666V83.761a1.223 1.223 0 011.22-1.223zm0 0"
            fill="#fee543"
          />
          <path
            data-name="Path 2087"
            d="M125.211 113.735a3.059 3.059 0 003.058-3.059h-6.113a3.059 3.059 0 003.055 3.059zm0 0"
            fill="#165a9f"
          />
          <path
            data-name="Path 2088"
            d="M132.407 95.6a.611.611 0 00-.467-.217h-.612V82.538a.612.612 0 10-1.223 0v12.846h-1.224v-14.07a3.67 3.67 0 10-7.34 0v14.07h-1.224V82.538a.612.612 0 10-1.223 0v12.846h-.612a.611.611 0 00-.6.712l1.223 7.341a.612.612 0 00.6.511h1.836v6.729a3.67 3.67 0 107.34 0v-6.733h1.835a.612.612 0 00.6-.511l1.223-7.341a.612.612 0 00-.132-.492zm-9.643-14.286a2.447 2.447 0 114.894 0v14.07h-1.205l.268-.141a.612.612 0 000-1.082l-1.424-.753 1.423-.751a.612.612 0 000-1.082l-1.422-.751 1.422-.751a.612.612 0 000-1.082l-1.419-.747 1.419-.749a.612.612 0 000-1.083l-1.421-.749 1.421-.749a.612.612 0 10-.571-1.082l-2.447 1.29a.612.612 0 000 1.082l1.42.749-1.42.748a.612.612 0 000 1.083l1.42.749-1.421.749a.612.612 0 000 1.083l1.422.751-1.422.75a.612.612 0 000 1.082l1.424.754-1.291.682h-1.07zm0 28.75v-1.22h4.894v1.223zm4.894-2.447h-4.894v-1.223h4.894zm-2.447 5.506a2.447 2.447 0 01-2.36-1.835h4.719a2.447 2.447 0 01-2.36 1.835zm2.447-7.952h-4.894v-1.227h4.894zm2.54-2.447h-9.974l-1.019-6.117h12.012zm0 0"
            fill="#231f20"
          />
        </g>
        <path
          data-name="Path 2241"
          d="M382.177 213.77a5.134 5.134 0 01-5.135-5.135h10.27a5.133 5.133 0 01-5.135 5.135zm0 0"
          fill="#003586"
        />
        <path
          data-name="Path 2242"
          d="M377.217 219.757a1.71 1.71 0 11-.171-.009 1.053 1.053 0 01.171.009zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2243"
          d="M387.331 219.752a1.7 1.7 0 11-.18.009 1.227 1.227 0 01.18-.009zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2244"
          d="M408.726 234.31v3.423a4.279 4.279 0 11-8.558 0v-3.423zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2245"
          d="M391.626 243.724h-.017a3.414 3.414 0 01-3.423-3.413v-2.578h6.847v2.578a3.416 3.416 0 01-3.407 3.413zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2246"
          d="M378.772 253.148h6.847a3.424 3.424 0 01-6.847 0zm0 0"
          fill="#ccd1d9"
        />
        <path
          data-name="Path 2247"
          d="M387.518 251.505a10.98 10.98 0 005.8 1.643h-22.249a10.976 10.976 0 005.8-1.643 11.091 11.091 0 005.324-9.483 11.091 11.091 0 005.325 9.483zm0 0"
          fill="#e6e9ed"
        />
        <path
          data-name="Path 2248"
          d="M372.756 243.724a3.414 3.414 0 01-3.4-3.413v-2.578h6.847v2.578h-.009a3.412 3.412 0 01-3.414 3.413zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2249"
          d="M364.223 234.31v3.423h-.009a4.275 4.275 0 11-8.549 0v-3.423zm0 0"
          fill="#ffd200"
        />
        <path
          data-name="Path 2250"
          d="M382.181 214.628a6 6 0 01-5.991-5.99.856.856 0 111.712 0 4.279 4.279 0 108.558 0 .856.856 0 111.712 0 6 6 0 01-5.991 5.99zm0 0"
        />
        <path
          data-name="Path 2251"
          d="M371.069 254.002a12 12 0 01-11.982-11.981.856.856 0 111.712 0 10.271 10.271 0 0020.541 0 .856.856 0 111.712 0 12 12 0 01-11.982 11.982zm0 0"
        />
        <path
          data-name="Path 2252"
          d="M376.882 252.366a.856.856 0 01-.482-.149 10.292 10.292 0 01-4.495-8.505.856.856 0 111.712 0 8.58 8.58 0 003.748 7.091.856.856 0 01-.483 1.564zm0 0"
        />
        <path
          data-name="Path 2253"
          d="M382.181 242.873a.855.855 0 01-.856-.856v-28.263a.856.856 0 111.712 0v28.267a.855.855 0 01-.856.852zm0 0"
        />
        <path
          data-name="Path 2254"
          d="M359.942 242.871a5.138 5.138 0 01-5.132-5.133.856.856 0 111.712 0 3.421 3.421 0 106.842 0 .856.856 0 111.712 0 5.138 5.138 0 01-5.132 5.133zm0 0"
        />
        <path
          data-name="Path 2255"
          d="M364.222 238.594a.855.855 0 01-.856-.856v-3.427a.856.856 0 111.712 0v3.427a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2256"
          d="M355.664 238.594a.855.855 0 01-.856-.856v-3.427a.856.856 0 111.712 0v3.427a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2257"
          d="M364.222 235.163h-8.558a.856.856 0 010-1.712h8.558a.856.856 0 010 1.712zm0 0"
        />
        <path
          data-name="Path 2258"
          d="M372.78 244.585a4.281 4.281 0 01-4.277-4.277.856.856 0 111.712 0 2.565 2.565 0 105.13 0 .856.856 0 111.712 0 4.281 4.281 0 01-4.277 4.277zm0 0"
        />
        <path
          data-name="Path 2259"
          d="M376.204 241.159a.855.855 0 01-.856-.856v-2.569a.856.856 0 111.712 0v2.569a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2260"
          d="M369.359 241.159a.855.855 0 01-.856-.856v-2.569a.856.856 0 111.712 0v2.569a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2261"
          d="M376.203 238.594h-6.845a.856.856 0 010-1.712h6.845a.856.856 0 110 1.712zm0 0"
        />
        <path
          data-name="Path 2262"
          d="M393.321 254.002a12 12 0 01-11.982-11.981.856.856 0 111.712 0 10.271 10.271 0 0020.542 0 .856.856 0 111.712 0 12 12 0 01-11.984 11.981zm0 0"
        />
        <path
          data-name="Path 2263"
          d="M387.509 252.366a.856.856 0 01-.483-1.564 8.58 8.58 0 003.748-7.091.856.856 0 011.712 0 10.293 10.293 0 01-4.495 8.505.855.855 0 01-.482.149zm0 0"
        />
        <path
          data-name="Path 2264"
          d="M404.449 242.871a5.138 5.138 0 01-5.132-5.133.856.856 0 111.712 0 3.421 3.421 0 106.842 0 .856.856 0 111.712 0 5.138 5.138 0 01-5.134 5.133zm0 0"
        />
        <path
          data-name="Path 2265"
          d="M400.169 238.594a.855.855 0 01-.856-.856v-3.427a.856.856 0 111.712 0v3.427a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2266"
          d="M408.727 238.594a.855.855 0 01-.856-.856v-3.427a.856.856 0 111.712 0v3.427a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2267"
          d="M408.727 235.163h-8.558a.856.856 0 110-1.712h8.558a.856.856 0 110 1.712zm0 0"
        />
        <path
          data-name="Path 2268"
          d="M391.61 244.585a4.281 4.281 0 01-4.277-4.277.856.856 0 111.712 0 2.565 2.565 0 105.13 0 .856.856 0 111.712 0 4.281 4.281 0 01-4.277 4.277zm0 0"
        />
        <path
          data-name="Path 2269"
          d="M388.187 241.159a.855.855 0 01-.856-.856v-2.569a.856.856 0 111.712 0v2.569a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2270"
          d="M395.032 241.159a.855.855 0 01-.856-.856v-2.569a.856.856 0 111.712 0v2.569a.855.855 0 01-.856.856zm0 0"
        />
        <path
          data-name="Path 2271"
          d="M395.032 238.594h-6.845a.856.856 0 110-1.712h6.845a.856.856 0 110 1.712zm0 0"
        />
        <path
          data-name="Path 2272"
          d="M393.321 254.002H371.07a.856.856 0 010-1.712h22.251a.856.856 0 010 1.712zm0 0"
        />
        <path
          data-name="Path 2273"
          d="M377.056 230.895a.856.856 0 010-1.712 4.3 4.3 0 004.293-4.293.856.856 0 011.712 0 6.012 6.012 0 01-6.005 6.005zm0 0"
        />
        <path
          data-name="Path 2274"
          d="M382.205 225.76a.855.855 0 01-.856-.856 4.3 4.3 0 00-4.293-4.293.856.856 0 010-1.712 6.012 6.012 0 016 6 .856.856 0 01-.851.861zm0 0"
        />
        <path
          data-name="Path 2275"
          d="M377.055 224.041a2.571 2.571 0 112.571-2.571 2.574 2.574 0 01-2.571 2.571zm0-3.43a.859.859 0 10.859.859.859.859 0 00-.859-.859zm0 0"
        />
        <path
          data-name="Path 2276"
          d="M387.331 230.895a6.011 6.011 0 01-6-6 .856.856 0 011.712 0 4.3 4.3 0 004.293 4.293.856.856 0 010 1.712zm0 0"
        />
        <path
          data-name="Path 2277"
          d="M382.182 225.76a.855.855 0 01-.856-.856 6.011 6.011 0 016-6 .856.856 0 010 1.712 4.3 4.3 0 00-4.293 4.293.855.855 0 01-.851.851zm0 0"
        />
        <path
          data-name="Path 2278"
          d="M387.331 224.041a2.571 2.571 0 112.571-2.571 2.574 2.574 0 01-2.571 2.571zm0-3.43a.859.859 0 10.859.859.86.86 0 00-.859-.859zm0 0"
        />
        <path
          data-name="Path 2279"
          d="M387.319 209.493h-10.27a.856.856 0 110-1.712h10.27a.856.856 0 110 1.712zm0 0"
        />
        <path
          data-name="Path 2280"
          d="M382.194 257.424a4.284 4.284 0 01-4.279-4.279.856.856 0 111.712 0 2.567 2.567 0 005.135 0 .856.856 0 111.712 0 4.284 4.284 0 01-4.28 4.279zm0 0"
        />
      </g>
    </svg>
  )
}

export default SvgComponent
